import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) {
    window.location.assign(`/#${id}`);
    return;
  }
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Reveal = ({ children, delay = 0, y = 36, className }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ num, chapter, title, sub, dark = false, id }) => (
  <div className="max-w-3xl" data-testid={`section-heading-${id}`}>
    <Reveal>
      <div className="flex items-center gap-4 mb-6">
        <span className="font-display text-sm font-700 font-semibold tracking-[0.25em] text-ecamber">{num}</span>
        <span className={`h-px w-12 ${dark ? "bg-white/30" : "bg-ecnavy/20"}`} />
        <span className={`text-xs font-semibold uppercase tracking-[0.3em] ${dark ? "text-white/60" : "text-ecnavy/60"}`}>
          {chapter}
        </span>
      </div>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className={`font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.1] ${dark ? "text-white" : "text-ecdeep"}`}>
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base md:text-lg leading-relaxed ${dark ? "text-white/70" : "text-slate-600"}`}>{sub}</p>
      </Reveal>
    )}
  </div>
);
